import Component, { Topic } from 'component';
import { assert } from 'utils';
customElements.define('x-product-gallery', class extends Component {
    constructor() {
        super();
        this.$element.containerRoot = this.querySelector('[data-product-gallery-element="container-root"]');
        this.$element.track = this.querySelector('[data-product-gallery-element="track"]');
        this.$element.modalImages = this.querySelectorAll('[data-product-gallery-element="modal-images"]');
        this.$element.thumbsCheck = this.querySelectorAll('[data-product-gallery-element="thumbs-check"]');
    }
    currentIndex;
    currentImageIndex;
    modal = null;
    modalId;
    mediaList;
    mobileMediaItemWidth = 0;
    scrollSnapSupport = false;
    ignoreMobileIntersections = false;
    render() {
        this.watchViewport = true;
        assert(Boolean(this.$element.track?.childElementCount), "Product doesn't have any medias");
        this.modalId = this.getAttribute('modal-id');
        this.currentImageIndex = Number(this.getAttribute('current-image-index'));
        this.initModal();
        this.initVideoControl();
        this.on(this, 'change', (e) => {
            e.stopPropagation();
            const target = e.target;
            this.setCurrentIndex(Number(target.value));
            if (target.dataset.imageIndex) {
                this.setCurrentImageIndex(Number(target.dataset.imageIndex));
            }
            if (this.mobileQuery.matches) {
                this.scrollToActiveMedia(Number(target.value));
            }
        });
        this.sub(Topic.PRODUCT_GALLERY_UPDATE, (currentIndex) => {
            if (this.setCurrentIndex(currentIndex)) {
                this.setCurrentThumb();
            }
            if (this.mobileQuery.matches) {
                this.scrollToActiveMedia(currentIndex);
            }
        });
    }
    onMobile() {
        this.mediaList = this.querySelectorAll('[data-media]');
        this.mobileMediaItemWidth = this.mediaList.item(0).clientWidth;
        this.scrollSnapSupport = 'onscrollsnapchange' in window;
        this.currentIndex = Number(this.getAttribute('current-index'));
        if (this.currentIndex) {
            this.scrollToActiveMedia(this.currentIndex);
        }
        if (this.scrollSnapSupport) {
            this.on(this.$element.track, 'scrollsnapchange', this.handleSnapChange);
        }
        else {
            const mobileGalleryObserver = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && !this.ignoreMobileIntersections) {
                        const target = entry.target;
                        const activeIndex = Number(target.dataset.media);
                        console.log(activeIndex);
                        if (this.setCurrentIndex(activeIndex)) {
                            this.setCurrentThumb();
                        }
                    }
                });
            }, { root: this.$element.containerRoot, threshold: 0.9 });
            this.mediaList.forEach(media => mobileGalleryObserver.observe(media));
        }
    }
    scrollToActiveMedia(index) {
        if (!this.scrollSnapSupport) {
            this.ignoreMobileIntersections = true;
        }
        this.$element.track?.scrollTo({
            left: this.mobileMediaItemWidth * index,
            behavior: 'smooth'
        });
        if (!this.scrollSnapSupport) {
            setTimeout(() => {
                this.ignoreMobileIntersections = false;
            }, 1000);
        }
    }
    handleSnapChange(e) {
        const target = e.snapTargetInline;
        const activeIndex = Number(target.dataset.media);
        if (this.setCurrentIndex(activeIndex)) {
            this.setCurrentThumb();
        }
    }
    initModal() {
        customElements.whenDefined('x-modal').then(() => {
            if (this.modalId) {
                this.modal = document.getElementById(this.modalId);
                this.modal.beforeOpen = this.scrollToModalImage.bind(this);
            }
        });
    }
    initVideoControl() {
        const videos = this.querySelectorAll('[data-type-video]');
        if (videos.length > 0) {
            const observer = new IntersectionObserver(this.handleVideoControl.bind(this), {
                root: this.$element.containerRoot,
                threshold: 0.5
            });
            videos.forEach(video => observer.observe(video));
        }
    }
    setCurrentThumb() {
        if (this.currentIndex === undefined) {
            return;
        }
        const currentThumb = this.$element.thumbsCheck?.item(this.currentIndex);
        if (currentThumb) {
            currentThumb.checked = true;
            if (this.thumbsAside && !this.mobileQuery.matches) {
                currentThumb.scrollIntoView({
                    block: 'nearest',
                    behavior: 'smooth'
                });
            }
            if (currentThumb.dataset.imageIndex) {
                this.setCurrentImageIndex(Number(currentThumb.dataset.imageIndex));
            }
        }
    }
    setCurrentIndex(currentIndex) {
        if (currentIndex === this.currentIndex) {
            return false;
        }
        this.style.setProperty('--product-gallery-current-index', currentIndex.toString());
        this.currentIndex = currentIndex;
        return true;
    }
    setCurrentImageIndex(currentImageIndex) {
        if (currentImageIndex === this.currentImageIndex) {
            return;
        }
        this.currentImageIndex = currentImageIndex;
        return true;
    }
    scrollToModalImage() {
        if (this.currentImageIndex !== undefined) {
            const target = this.$element.modalImages?.item(this.currentImageIndex);
            if (target) {
                target.scrollIntoView({
                    block: 'center'
                });
            }
        }
    }
    handleVideoControl(entries) {
        entries.forEach(entry => {
            const video = entry.target.firstElementChild;
            const isHTMLVideo = video?.tagName === 'VIDEO';
            if (!entry.isIntersecting) {
                if (isHTMLVideo) {
                    this.handleHTMLVideo(video);
                }
                else if (video?.tagName === 'IFRAME') {
                    const videoHost = entry.target.getAttribute('video-host');
                    this.pauseExternalVideo(video, videoHost);
                }
            }
            if (entry.isIntersecting && this.videoAutoplay && isHTMLVideo) {
                this.handleHTMLVideo(video, true);
            }
        });
    }
    handleHTMLVideo(video, play = false) {
        play ? video.play() : video.pause();
    }
    pauseExternalVideo(embeddedVideo, videoHost) {
        const videoFrame = embeddedVideo.contentWindow;
        if (videoHost === 'youtube') {
            videoFrame.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
        }
        else if (videoHost === 'vimeo') {
            videoFrame.postMessage('{"method":"pause"}', '*');
        }
    }
    get thumbsAside() {
        return this.hasAttribute('thumbs-aside');
    }
    get videoAutoplay() {
        return this.hasAttribute('video-autoplay');
    }
});
